import { render } from "./OcrVerificationForm.vue?vue&type=template&id=18809f1b&scoped=true"
import script from "./OcrVerificationForm.vue?vue&type=script&lang=js"
export * from "./OcrVerificationForm.vue?vue&type=script&lang=js"

import "./OcrVerificationForm.vue?vue&type=style&index=0&id=18809f1b&lang=scss"
import "./OcrVerificationForm.vue?vue&type=style&index=1&id=18809f1b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18809f1b"]])

export default __exports__